import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService, Config } from '@increff/commons';
import { Observable } from 'rxjs';
import { APPLICATION, APP_RESOURCE, APP_ROLE } from '../../interfaces/application.interface';
import { Rest } from '../rest.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationsService {

    constructor(
      private abstractService: AbstractService, private urls: Rest,
       private config: Config
    ) { }

    getAllApplications(): Observable<APPLICATION[]> {
        return this.abstractService?.exec(this.urls.allApplicationsUrl, 'GET', undefined, { ...this.config?.startupData?.extraHttpOptions });
    }

    updateApplicationDetails(applicationDetails: APPLICATION): Observable<APPLICATION> {
        return this.abstractService?.exec(this.urls.updateApplicationUrl, 'PUT', applicationDetails, { ...this.config?.startupData?.extraHttpOptions });
    }

    addNewApplication(applicationDetails: APPLICATION): Observable<any> {
        return this.abstractService?.exec(this.urls.addApplicationUrl, 'POST', applicationDetails, { ...this.config?.startupData?.extraHttpOptions });
    }

    getApplicationRoles(appName: string): Observable<APP_ROLE[]>{
        const params = new HttpParams()?.set('appName', appName);
        return this.abstractService?.exec(this.urls.applicationRolesUrl, 'GET', undefined, {params, ...this.config?.startupData?.extraHttpOptions});
    }

    addNewApplicationRole(roleData: APP_ROLE): Observable<APP_ROLE[]>{
        return this.abstractService?.exec(this.urls.addApplicationRoleUrl, 'POST', roleData, { ...this.config?.startupData?.extraHttpOptions });
    }

    deleteApplicationRole(roleId: number): Observable<any>{
        return this.abstractService?.exec(this.urls.getDeleteApplicationRoleUrl(roleId), 'DELETE', undefined, { ...this.config?.startupData?.extraHttpOptions });
    }

    getApplicationResources(appName?: string): Observable<APP_RESOURCE[]>{
        const params = new HttpParams()?.set('appName', appName);
        return this.abstractService?.exec(
            appName ? this.urls.adminApplicationResourcesUrl : this.urls.domainApplicationResourcesUrl,
            'GET',
            undefined,
            appName ? {params, ...this.config?.startupData?.extraHttpOptions} : { ...this.config?.startupData?.extraHttpOptions }
        );
    }

    addNewApplicationResource(resourceData: APP_RESOURCE): Observable<APP_RESOURCE[]>{
        return this.abstractService?.exec(this.urls.addAdminApplicationResourceUrl, 'POST', resourceData, { ...this.config?.startupData?.extraHttpOptions });
    }
}
